const f = ({
  condition: a,
  wrapper: s,
  OrWrapper: t,
  children: o
}) => a ? s(o) : t ? t(o) : o;
export {
  f as default
};
//# sourceMappingURL=ConditionalWrapper.es.js.map
